export const RAD2DEG = 180 / Math.PI;
export const DEG2RAD = Math.PI / 180;
